// Boot gate for Amplify configuration (Pas 1.1: mount imediat).
// main.js mounts the app first and configures Amplify in the background;
// anything that calls Amplify Auth (Login, SignInCallback, protected
// routes) must await this promise first, otherwise fetchAuthSession()
// throws "not configured" and Login would treat a persisted user as
// logged out (and actively log them out). Resolves true once
// Amplify.configure() has run, false when boot config failed (callers
// then proceed exactly as the old mount-on-error path did).
let resolveReady: ((ok: boolean) => void) | null = null;
let settled: boolean | null = null;

export const authReady: Promise<boolean> = new Promise<boolean>((resolve) => {
  resolveReady = resolve;
});

export function markAuthReady(ok: boolean): void {
  if (settled !== null) return; // first settlement wins
  settled = ok;
  resolveReady?.(ok);
}

export function isAuthReady(): boolean | null {
  return settled;
}
